/**
 * Checks if a value is null or undefined
 * Replacement for deprecated util.isNullOrUndefined
 * @param value - The value to check
 * @returns true if the value is null or undefined, false otherwise
 */
export function isNullOrUndefined(value: unknown): value is null | undefined {
  return value === null || value === undefined;
}
